<template>
  <jade-box
    hasPadding
    class="eu-mt_5 eu-mb_3"
  >
    <div class="timeline-onboarding">
      <div class="timeline-onboarding__img--container">
        <img
          :src="require('@/assets/timeline-onboarding/trophy.svg').default"
        />
      </div>

      <div class="timeline-onboarding__text--container">
        <jade-text
          color="neutral"
          data-testid="text-timeline-title"
          variant="text-large"
          weight="semibold"
          >{{ $t('fullActivation.title') }}
        </jade-text>

        <jade-text
          color="medium"
          variant="text-medium"
          weight="regular"
          >{{ $t('fullActivation.description') }}
          <jade-text
            :href="$sanitize(blogURL)"
            as="a"
            color="current-color"
            rel="noopener noreferrer"
            target="_blank"
            weight="semibold"
            >{{ $t('fullActivation.blog') }}</jade-text
          >
          <jade-text
            as="span"
            color="current-color"
            >{{ $t('fullActivation.descriptionPart2') }}</jade-text
          >
          <jade-text
            :href="$sanitize(helpURL)"
            as="a"
            color="current-color"
            target="_blank"
            weight="semibold"
            >{{ $t('fullActivation.helpCenter') }}
          </jade-text>
          <jade-text
            as="span"
            color="current-color"
            >{{ $t('fullActivation.descriptionPart3') }}
          </jade-text>
          <jade-text
            as="span"
            color="current-color"
            weight="semibold"
            >{{ $t('fullActivation.phone') }}
          </jade-text>
          <jade-text
            as="span"
            color="current-color"
            >{{ $t('fullActivation.descriptionPart4') }}
          </jade-text>
          <jade-text
            as="span"
            color="current-color"
            weight="semibold"
            >{{ $t('fullActivation.email') }}
          </jade-text>
        </jade-text>
      </div>

      <div class="timeline-onboarding__close--container">
        <jade-button
          icon="close"
          size="medium"
          variant="neutral-ghost"
          @click.prevent="closeFullActivation"
        />
      </div>
    </div>
  </jade-box>
</template>

<script>
import { JadeBox, JadeButton, JadeText } from '@/components/jade'
import { EXTERNAL_ENDPOINTS } from '@/external-endpoints'

export default {
  name: 'StepFullActivation',
  components: {
    JadeBox,
    JadeText,
    JadeButton
  },
  computed: {
    blogURL () {
      return EXTERNAL_ENDPOINTS.SITE.blog.url()
    },
    helpURL () {
      return EXTERNAL_ENDPOINTS.HELP.url()
    }
  },
  methods: {
    closeFullActivation () {
      this.$emit('closeFullActivation')
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';

.timeline-onboarding {
  display: grid;
  grid-template-areas: 'img close' 'main main';
  grid-template-columns: 1fr 1fr;
  column-gap: var(--global-space-400, 32px);
  row-gap: var(--global-space-150, 12px);
}

@media only screen and (min-width: 768px) {
  .timeline-onboarding {
    grid-template-areas: 'img main close';
    grid-template-columns: 60px 1fr 50px;
  }
}

.timeline-onboarding__img--container {
  grid-area: img;
}

.timeline-onboarding__text--container {
  grid-area: main;
  max-width: 690px;
}

.timeline-onboarding__close--container {
  grid-area: close;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

<i18n>
{
  "pt-BR": {
    "fullActivation": {
      "title": "Parabéns! Sua conta está pronta para vender!",
      "description": "Saiba como a Pagar.me pode te ajudar a escalar suas vendas, confira nosso",
      "descriptionPart2": ", ou a ",
      "blog": "Blog",
      "helpCenter": "Central de Ajuda!",
      "descriptionPart3": "Em caso de dúvidas entre em contato pelo telefone ",
      "phone": "4004-1330",
      "descriptionPart4": " ou e-mail ",
      "email": "relacionamento@pagar.me"
    }
  },
  "en-US": {
    "fullActivation": {
      "title": "Congratulations! Your account is ready to sell!",
      "description": "Learn how Pagar.me can help you scale your sales, check out our",
      "descriptionPart2": ", or a ",
      "blog": "Blog",
      "helpCenter": "Help Center!",
      "descriptionPart3": "If you have any questions, please contact us by phone",
      "phone": "4004-1330",
      "descriptionPart4": " or email ",
      "email": "relacionamento@pagar.me"
    }
  }
}
</i18n>
